import React, { useEffect, useMemo, useState } from 'react';
import './PayntWidget.css';
import PaymentProcessingModal from '../../layout/PaymentProcessingModal';
import { Brands } from '../../../../models/brands';
import { usePaymentStatusPolling } from '../../../../hooks/usePaymentStatusPolling';

// Extend Window interface to include our custom function
declare global {
    interface Window {
        handlePaymentModalOpen?: () => void;
    }
}

const PayntWidget: React.FC<{ checkoutId: string; brandId: Brands }> = ({
    checkoutId,
    brandId,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { paymentStatus } = usePaymentStatusPolling({
        checkoutId,
        isPolling: isModalOpen,
    });

    const wpwlOptionString = useMemo(
        () =>
            `var wpwlOptions = {
                style: "card",
                shopperResultUrl: "${window.location.href}",
                googlePay: {
                    merchantName: "URocked",
                    shippingOptionRequired: false,
                    buttonType: "pay",
                    gatewayMerchantId: "${process.env.REACT_APP_GOOGLE_GATEWAY_MERCHANT_ID}",
                    merchantId: "${process.env.REACT_APP_GOOGLE_MERCHANT_ID}",
                },
                applePay: {
                    displayName: "URocked",
                    buttonType: "pay",
                    merchantIdentifier: "${process.env.REACT_APP_APPLE_MERCHANT_IDENTIFIER}",
                },
                onBeforeSubmitCard: function(event) {
                    if (window.handlePaymentModalOpen) {
                        window.handlePaymentModalOpen();
                    }

                    return true;
                }   
            }`,
        [],
    );

    const addScriptHtml = (innerHtml: string, id: string) => {
        if (!document.getElementById(id)) {
            const script = document.createElement('script');
            script.id = id;
            script.innerHTML = innerHtml;
            document.head.appendChild(script);
        }
    };

    const addScriptSrc = (src: string, id: string) => {
        if (!document.getElementById(id)) {
            const script = document.createElement('script');
            script.id = id;
            script.src = src;
            document.head.appendChild(script);
        }
    };

    // Expose function to window for wpwlOptions callback
    useEffect(() => {
        window.handlePaymentModalOpen = () => {
            setIsModalOpen(true);
        };

        return () => {
            delete window.handlePaymentModalOpen;
        };
    }, []);

    useEffect(() => {
        if (!checkoutId) return;
        addScriptHtml(wpwlOptionString, 'ur-wpwlOptions');
        addScriptSrc(
            `${process.env.REACT_APP_PAYNT_URL}?checkoutId=${checkoutId}`,
            'ur-checkoutScript',
        );

        return () => {
            const optionsScript = document.getElementById('ur-wpwlOptions');
            if (optionsScript) {
                optionsScript.remove();
            }

            const checkoutScript = document.getElementById('ur-checkoutScript');
            if (checkoutScript) {
                checkoutScript.remove();
            }
        };
    }, [checkoutId, wpwlOptionString]);

    return (
        <>
            <form
                action={`/payment/processing?checkoutId=${checkoutId}&brandId=${brandId}`}
                className="paymentWidgets"
                data-brands="MASTER VISA APPLEPAY GOOGLEPAY"
            ></form>
        </>
    );
};

export default PayntWidget;
